import * as DashboardConstants from "../../constants/DashboardConstants";
import {geCSVColumns, getByColName, resultSetSize} from "./DashBoardResultSetUtil";
import {fillWithLastElement} from "../../common/CollectionsUtility";
import * as kendoThemeChooser from "../KednoThemeChooser";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";
import {addLinkOptionsToPoint} from "../highCharts/HighPieChartDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createColumnsChart(userDashboardChartLine, h, w, widget, chartArea) {
    let values = userDashboardChartLine.resultSet;
    let params = userDashboardChartLine.parameters;
    let categs = [];
    let labelWithValues = new Map();
    let categParam = params[DashboardConstants.Param_Label] || "";
    let labelParam = params[DashboardConstants.Param_Category] || "";
    let valueParam = params[DashboardConstants.Param_Value] || "";
    for (let i = 0; i < resultSetSize(values); i++) {
        if (categParam.contains(",") || labelParam.contains(",") || valueParam.contains(",")) {
            let rowCategories = geCSVColumns(i, categParam, values);
            let rowLabels = geCSVColumns(i, labelParam, values);
            let rowValues = geCSVColumns(i, valueParam, values);
            let maxSize = Math.max(rowCategories.size(), rowLabels.size(), rowValues.size());
            fillWithLastElement(rowCategories, maxSize);
            fillWithLastElement(rowLabels, maxSize);
            fillWithLastElement(rowValues, maxSize);
            for (let x = 0; x < maxSize; x++) {
                addDataLine(categs, labelWithValues, rowCategories.get(x), rowLabels.get(x), rowValues.get(x), params, values, i);
            }
        } else {
            addDataLine(categs, labelWithValues, getByColName(i, categParam, values), getByColName(i, labelParam, values), getByColName(i, valueParam, values), params, values, i);
        }
    }
    let dataSeries = [];
    for (let [label, values] of labelWithValues.entries()) {
        for (let val of values)
            dataSeries.push(val);
    }
    widget.kendoChart({
        theme: kendoThemeChooser.currentTheme(),
        legend: {
            visible: false
        },
        categoryAxis: [{
            categories: categs,
        }],
        series: [{
            type: "column",
            data: dataSeries,
            labels: {
                visible: true,
            },
        }],
        chartArea: chartArea,
        valueAxis: {
            title: {
                text: calcChartTitle(userDashboardChartLine),
                margin: 15,
                position: "top",
                font: "12px",
            }
        },
        tooltip: {
            visible: true,
            format: "{0}%",
            template: "#= category #<br> #= value #"
        }
    });
    return widget;
}

export function addDataLine(categs, labelWithValues, category, label, value, params, values, i) {
    if (!categs.contains(category))
        categs.push(category);
    if (!labelWithValues.get(label))
        labelWithValues.set(label, []);
    let point = {y: parseFloat(value)};
    addLinkOptionsToPoint(params, values, i, point);
    labelWithValues.get(label).push(point);

}